const Dom = {};
const getters = {
    'body'              : ()=>document.getElementsByTagName("body")[0],

    // accesibility
    'focusable'         : ()=>document.querySelectorAll("a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable], *[data-notab]"),

    // Modal
    'modalTrigger'      : ()=>document.querySelectorAll('[modal-target]'),
    'closeModal'        : ()=>document.querySelectorAll('.modal__close'),
    'closeAnyModal'     : ()=>document.querySelectorAll('[data-dismiss="allModal"]'),
    'closeButton'       : ()=>document.querySelectorAll('[close-button]'),
}
// Creates a set of getters that will fetch a fresh value each time that it is accessed.
Object.entries(getters).forEach(([key,getter])=>{
    Object.defineProperty(Dom, key, {
        get: getter,
    })
});


export default Dom;
